import { ApiEndpoint } from 'controller/endpoint'
import { HttpRequestForApiV4 } from 'utils/http'
import { IPerformerDataActiveEvents, IPerformerMetadata } from 'meta/pages/v4/performer'

type Props = {
  code: string
  page: number
}

type Response = { data: IPerformerDataActiveEvents, metadata: IPerformerMetadata }

export const getActiveEvents = async (props: Props): Promise<Response> => {
  const { code, page } = props

  const endpoint = ApiEndpoint.v4.performer.activeEvents(code, page)
 
  const { data, metadata } = await HttpRequestForApiV4.get<
    IPerformerDataActiveEvents,
    IPerformerMetadata>(endpoint)
  
  return { data, metadata }
}
